// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
export default function debounce(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = () => {
            // @ts-expect-error see https://github.com/mui/material-ui/blob/master/packages/mui-utils/src/debounce/debounce.ts
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = () => {
        clearTimeout(timeout);
    };
    return debounced;
}
//# sourceMappingURL=debounce.js.map